import React from "react";
import "./App.css";
import Career from "./Components/Page/Tabs/Career";
import Contact from "./Components/Page/Tabs/Contact";
import About from "./Components/Page/Tabs/About";
import Fees from "./Components/Page/Tabs/Fees";
import NavBar from "./Components/Navbar";
import Home from "./Components/MainPage/Home";
import Acupuncture from "./Components/Page/Services/Acupuncture";
import Chiropractic from "./Components/Page/Services/Chiropractic";
import Fascial from "./Components/Page/Services/Fascial";
import Massage from "./Components/Page/Services/Massage";
import Orthotics from "./Components/Page/Services/Orthotics";
import DrMackenzie from "./Components/Page/Team/DrMackenzie";
import AthwalRMT from "./Components/Page/Team/AthwalRMT";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Footer from "./Components/Footer";
import DrEmma from "./Components/Page/Team/DrEmma";
import Forum from "./Components/Page/Team/Forum";
import Pelvic from "./Components/Page/Services/Pelvic";

function App() {
  return (
    <div className="page-container">
      <div className="content-wrap">
        <Router>
          <NavBar />
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/DrMackensie">
              <DrMackenzie />
            </Route>
            <Route path="/AthwalRMT">
              <AthwalRMT />
            </Route>
            <Route path="/DrEmma">
              <DrEmma />
            </Route>
            <Route path="/ForumPT">
              <Forum />
            </Route>
            <Route path="/fees">
              <Fees />
            </Route>
            <Route path="/Chiropractic">
              <Chiropractic />
            </Route>
            <Route path="/Massage">
              <Massage />
            </Route>
            <Route path="/FST">
              <Fascial />
            </Route>
            <Route path="/Acupuncture">
              <Acupuncture />
            </Route>
            <Route path="/Orthotics">
              <Orthotics />
            </Route>
            <Route path="/Pelvic">
              <Pelvic />
            </Route>
          </Switch>
          <Footer />
        </Router>
      </div>
    </div>
  );
}

export default App;
